import { WEEKDAYS } from "./constants";
import { Utils } from "./Utils";
import { API } from "./API";

export class DaySelector {
  constructor(onDateSelect) {
    this.swiper = null;
    this.onDateSelect = onDateSelect;
    this.bookingDates = new Set();
  }

  async initialize(currentDate, selectedDate) {
    await this.fetchBookingDates(currentDate);

    const weekView = document.getElementById("weekView");
    weekView.innerHTML = "";

    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      weekView.appendChild(this.createDaySlide(date, selectedDate));
    }

    this.initializeSwiper(month, selectedDate);
  }

  async fetchBookingDates(currentDate) {
    try {
      const month = (currentDate.getMonth() + 1).toString();
      const year = currentDate.getFullYear().toString();

      const data = await API.getBookingDates(month, year);
      if (data.success) {
        this.bookingDates = new Set(data.dates);
      }
    } catch (error) {
      console.error("Error fetching booking dates:", error);
    }
  }

  createDaySlide(date, selectedDate) {
    const slide = document.createElement("div");
    slide.className = "swiper-slide";

    const button = document.createElement("button");
    button.className = `day-button flex flex-col items-center justify-center w-full h-full relative
            ${this.isSameDate(date, selectedDate) ? "selected" : ""}`;

    const weekday = document.createElement("div");
    weekday.className = "text-xs opacity-75";
    weekday.textContent = WEEKDAYS[this.getWeekDay(date)];

    const dayNum = document.createElement("div");
    dayNum.className = "text-lg font-bold";
    dayNum.textContent = date.getDate();

    if (this.hasBookings(date)) {
      const dot = document.createElement("div");
      dot.className = "absolute bottom-0 w-1 h-1 bg-cyan-600 rounded-full";
      button.appendChild(dot);
    }

    button.appendChild(weekday);
    button.appendChild(dayNum);

    button.addEventListener("click", () => this.onDateSelect(date));
    slide.appendChild(button);

    return slide;
  }

  hasBookings(date) {
    const formattedDate = Utils.formatDate(date);
    return this.bookingDates.has(formattedDate);
  }

  initializeSwiper(currentMonth, selectedDate) {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(".swiper", {
      slidesPerView: "auto",
      spaceBetween: 10,
      grabCursor: true,
      navigation: {
        nextEl: "#nextWeek",
        prevEl: "#prevWeek",
      },
    });

    if (selectedDate.getMonth() === currentMonth) {
      this.swiper.slideTo(selectedDate.getDate() - 1, 0);
    }
  }

  getWeekDay(date) {
    let day = date.getDay();
    return day === 0 ? 6 : day - 1;
  }

  isSameDate(date1, date2) {
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  }
}
